var map = {
	"./FF_PANDA-1.png": 3800,
	"./FF_PANDA-10.png": 1588,
	"./FF_PANDA-2.png": 96468,
	"./FF_PANDA-3.png": 83793,
	"./FF_PANDA-4.png": 2058,
	"./FF_PANDA-5.png": 1570,
	"./FF_PANDA-6.png": 54767,
	"./FF_PANDA-7.png": 58422,
	"./FF_PANDA-8.png": 43243,
	"./FF_PANDA-9.png": 25169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9933;